import "bootstrap/dist/css/bootstrap.min.css";
import React, { Component, createRef } from "react";
import { Animated } from "react-animated-css";
import { Accordion } from "react-bootstrap";
import { FaArrowCircleDown, FaArrowCircleUp } from "react-icons/fa";
import ArrowCircleUpOutlinedIcon from "@mui/icons-material/ArrowCircleUpOutlined";
import ArrowCircleDownOutlinedIcon from "@mui/icons-material/ArrowCircleDownOutlined";
import { TbArrowBackUp } from "react-icons/tb";
import { connect } from "react-redux";
import Spinner from "../../components/BackDrop_Spinner";
import Popup from "../../components/SimplePOPUP";
import CloseIcon from "@mui/icons-material/Close";
import { getRequest, postRequest } from "../../globalhelper/helper";
import DeleteIcon from "@mui/icons-material/Delete";
import {
    fetchTreeData,
    handleTreeChange,
    Set_ORG_ID_CONST,
    update_dependencyJson,
    update_one_side_PDF_Key,
    updateStoreVals,
} from "../../redux/VR2/vr2Actions";
import MyForm from "./form";
import MyTable from "./mytable";
import "./vr2FormRendering.css";
import ValidatePopUp from "./ValidatePopup";
import DialougeBox from "./DialougeBox";
import {
    Alert,
    AlertTitle,
    Box,
    CircularProgress,
    Drawer,
    IconButton,
    Snackbar,
    TextField,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
} from "@mui/material";
import {
    hideLoader,
    navUrl,
    showAlert,
    showLoader,
} from "../../redux/Common/commonActions";
import SaveAsRoundedIcon from "@mui/icons-material/SaveAsRounded";
import store from "../../store";

class DisplayContainer extends Component {
    constructor(props) {
        super(props);
        this.containerRef = createRef();
        this.emailContentRef = createRef();
        this.state = {
            DialougeBox: null,
            message: null,
            fnToCallonVendorIDonChange: null,
            showSpinner: false,
            popup_table: false,
            render: false,
            time: null,
            canQuit: true,
            showScrollButton: true,
            OldAccountingDate: "",
            ReferenceName: this.props.refName,
            token: this.props.screenName,
            rejectorApprovalStatus: null,
            status: (
                <div className="application-loader">
                    <div className="center">
                        <div className="wave"></div>
                        <div className="wave"></div>
                        <div className="wave"></div>
                        <div className="wave"></div>
                        <div className="wave"></div>
                        <div className="wave"></div>
                        <div className="wave"></div>
                        <div className="wave"></div>
                        <div className="wave"></div>
                        <div className="wave"></div>
                    </div>
                </div>
            ),
        };
    }

    handleExtend = async (ID, Name) => {
        try {
            this.setState({ showSpinner: true });
            let url =
                this.state.token === "ItemMaster"
                    ? `api/edureka/getItemJSONForExtension`
                    : `api/edureka/getVendorJSONForExtension`;

            let res = await getRequest(url);
            if (res.res.status === "success") {
                this.setState({ DialougeBox: true });
                let VR2Json = await res.res.data;
                await this.Give_Val_By_ServiceKey("Organization Name");

                const updatedJSONData = [...VR2Json];
                const children = updatedJSONData[1].children[0].children;

                const updateField = (title, value) => {
                    const index = children.findIndex((item) => item.title === title);
                    if (index !== -1) {
                        children[index].val = value;
                    }
                };

                updateField(
                    (this.state.token === "ItemMaster" && "Item Name") || "Vendor Name",
                    Name,
                );
                updateField(
                    (this.state.token === "ItemMaster" && "Item ID") || "Vendor ID",
                    ID,
                );
                updateField(
                    "Organization Name",
                    this.state?.Give_Val_By_ServiceKey?.["Organization Name"] || "",
                );
                updateField("Organization ID", this.props.ORG_ID_CONST);

                console.log(updatedJSONData);
                this.setState({
                    token:
                        this.state.token === "VendorMaster"
                            ? "VendorPreferences"
                            : this.state.token === "ItemMaster"
                                ? "ItemPreferences"
                                : this.state.token,
                });
                this.props.handleTreeChange(updatedJSONData);
            }
        } catch (error) {
            console.log(error);
        } finally {
            this.setState({ showSpinner: false });
        }
    };

    handleClose = () => {
        this.setState({ showpopup: false });
    };

    componentWillMount() {
        this.props.update_one_side_PDF_Key(false, "");
        this.props.handleTreeChange(null);
    }

    componentDidMount() {
        window.addEventListener("scroll", this.handleScroll);

        let screenAction =
            this.props.screenAction === "PartialCreate"
                ? "create"
                : this.props.screenAction;

        sessionStorage.setItem(
            "pageName",
            screenAction.charAt(0).toUpperCase() +
            screenAction.slice(1) +
            " " +
            this.state.token,
        );

        this.props.fetchTreeData();

        if (this.props.screenAction === "create") {
            this.props.showLoader();
            getRequest(
                `api/vr2/get_screen_json_repository?module=${localStorage.getItem(
                    "module",
                )}&screenName=${this.state.token}`,
            )
                .then((res) => {
                    if (res.res.status === "success") {
                        console.log(res.res.data);

                        this.props.handleTreeChange(res.res.data);
                        this.store_all_vals(res.res.data);
                        // this.props.handleTreeChange(j_son)
                        // this.store_all_vals(j_son)

                        if (this.state.token === "BillExtract") {
                            this.Store_ORG_ID("Organization ID");
                            this.putDefaultValue_BillExtract("DocumentType", "Bill");
                            this.putDefaultValue_BillExtract("ExchangeRate", "1");
                            this.putDefaultValue_BillExtract_copyFrom(
                                "Accounting Date",
                                "Invoice Date",
                            );
                        }
                        if (this.state.token === "GoodsAndServicesEntries") {
                            this.Store_ORG_ID("Receiver ID");
                        }

                        getRequest(
                            `api/vr2/get_screen_dependency_json?module=${localStorage.getItem(
                                "module",
                            )}&screenName=${this.state.token}`,
                        ).then((res) => {
                            if (res.res.status === "success") {
                                console.log(res.res.data);

                                this.props.update_dependencyJson(res.res.data);
                                // this.props.update_dependencyJson([])

                                this.setState({ render: true });
                            } else {
                                this.setState((prev) => ({
                                    ...prev,
                                    status: (
                                        <Box sx={{ margin: "auto" }}>
                                            <Alert severity="warning">
                                                <AlertTitle>No Data Found</AlertTitle>
                                                There is no data to display at the moment.
                                            </Alert>
                                        </Box>
                                    ),
                                }));
                            }
                        });
                    }
                })
                .catch((err) => console.log(err))
                .finally(() => this.props.hideLoader());
        } else if (
            this.props.screenAction === "edit" &&
            this.props.From_SearchJSON
        ) {
            this.props.handleTreeChange(this.props.From_SearchJSON);
            console.log(this.props.From_SearchJSON, "From_SearchJSON");

            this.store_all_vals(this.props.From_SearchJSON);
            getRequest(
                `api/vr2/get_screen_dependency_json?module=${localStorage.getItem(
                    "module",
                )}&screenName=${this.state.token}`,
            ).then((res) => {
                if (res.res.status === "success") {
                    this.props.update_dependencyJson(res.res.data);
                    this.setState({ render: true, status: null });
                }
            });
        } else if (
            (this.props.screenAction === "draft" ||
                this.props.screenAction === "edit" ||
                this.props.screenAction === "approval" ||
                this.props.screenAction === "PartialCreate") &&
            localStorage.getItem("api")
        ) {
            this.props.showLoader();

            console.log(localStorage.getItem("api"));

            getRequest(localStorage.getItem("api"))
                .then((res) => {
                    if (res.res.status === "success") {
                        console.log(res.res.data);

                        this.props.handleTreeChange(res.res.data);
                        this.store_all_vals(res.res.data);

                        this.props.noQuit && this.rerender("noQuit");
                        localStorage.removeItem("api");
                        setTimeout(async () => {
                            if (this.state.token === "BillExtract") {
                                this.getTDSAsExp("CIN Number", "select");
                                this.getTDSAsExp("GSTReference", "GSTasExp");
                                this.getTDSAsExp("TDSReference", "TDSasExp");

                                this.getTDSAsExp("PO/IP Type", "showSelect", true);

                                this.Store_ORG_ID("Organization ID");
                                this.putDefaultValue_BillExtract("DocumentType", "Bill");
                                this.putDefaultValue_BillExtract("ExchangeRate", "1");
                                this.putDefaultValue_BillExtract_copyFrom(
                                    "Accounting Date",
                                    "Invoice Date",
                                );

                                await this.Give_Val_By_ServiceKey("Accounting Date");
                                let OldAccountingDate =
                                    this.state?.Give_Val_By_ServiceKey?.["Accounting Date"] || "";
                                this.setState({ OldAccountingDate });
                                let Status = JSON.parse(
                                    localStorage.getItem("selectedItem"),
                                )?.Status;
                                this.handleValidatePopup(Status);
                            }
                            if (this.state.token === "GoodsAndServicesEntries") {
                                this.Store_ORG_ID("Receiver ID");
                                this.getTDSAsExp("DeductionRef", "DeductTDS");

                                await this.Give_Val_By_ServiceKey("Accounting Date");
                                let OldAccountingDate =
                                    this.state?.Give_Val_By_ServiceKey?.["Accounting Date"] || "";
                                this.setState({ OldAccountingDate });
                            }
                        }, 500);

                        getRequest(
                            `api/vr2/get_screen_dependency_json?module=${localStorage.getItem(
                                "module",
                            )}&screenName=${this.state.token}`,
                        ).then((res) => {
                            if (res.res.status === "success") {
                                this.props.update_dependencyJson(res.res.data);
                                this.setState({ render: true });
                            }
                        });
                    } else {
                        this.setState((prev) => ({
                            ...prev,
                            status: (
                                <Box sx={{ margin: "auto" }}>
                                    <Alert severity="warning">
                                        <AlertTitle>No Data Found</AlertTitle>
                                        There is no data to display at the moment.
                                    </Alert>
                                </Box>
                            ),
                        }));
                        this.props.hideLoader();
                    }
                })
                .catch((err) => console.log(err))
                .finally(() => this.props.hideLoader());
        } else {
            this.props.navUrl("/Dynamic_Forms", "Transact");
        }
    }

    handleValidatePopup = async (Status) => {
        try {
            await this.Give_Val_By_ServiceKey("Organization ID")
            let interimId = this.props.storeVals["billworkflowinfo#interimid"];
            let orgid = await this.state?.Give_Val_By_ServiceKey?.["Organization ID"] || "";
            if (this.state.message === null) {
                let response = await postRequest(
                    `api/vr2/validatePopup?interimId=${interimId}&orgid=${orgid}&Status=${Status}`,
                )

                if (response && response.res?.data?.message) {
                    const message = response.res.data.message;
                    console.log(response.res, "message");
                    this.setState({ showpopup: true, message });
                }
            } else {
                this.setState({ showpopup: true });
            }
        } catch (error) {
            console.error("API request failed:", error);

        }
    };

    handle3WayMatchingPopup = async () => {
        try {
            await this.Give_Val_By_ServiceKey("Organization ID")
            let interimId = this.props.storeVals["billworkflowinfo#interimid"];
            let orgid = await this.state?.Give_Val_By_ServiceKey?.["Organization ID"] || "";
            let response = await getRequest(
                `api/vr2/ThreeWayMatching?interimId=${interimId}&orgid=${orgid}`,
            )
            if (response && response.res?.data) {
                const DATA = response.res.data;
                console.log(response.res, "message", {
                    search: "",
                    data: DATA,
                    filteredData: DATA,
                    header: DATA.length ? Object.keys(DATA[0]) : [],
                });
                this.setState({
                    popup_table: {
                        search: "",
                        data: DATA,
                        filteredData: DATA,
                        header: DATA.length ? Object.keys(DATA[0]) : [],
                    },
                });
            }
        } catch (error) {
            console.error("API request failed:", error);
        }
    };

    componentWillUnmount() {
        window.removeEventListener("scroll", this.handleScroll);
    }

    Give_Val_By_ServiceKey = (serviceKey) => {
        console.log(serviceKey, "Give_Val_By_ServiceKey");

        let VALUE;

        let VR2_Form_Json = this.props.VR2_Form_Json;

        let found = false;

        this.setState(
            {
                ...this.state,
                Give_Val_By_ServiceKey: {
                    ...this.state.Give_Val_By_ServiceKey,
                    [serviceKey]: "",
                },
            },
            () => {
                VR2_Form_Json?.forEach((each, i) => {
                    if (found) return VALUE;
                    if (each.children && each.children.length) {
                        each.children.forEach((each2, j) => {
                            if (found) return VALUE;
                            if (each2.children && each2.children.length) {
                                each2.children.forEach((each3, k) => {
                                    if (found) return VALUE;

                                    if (
                                        !each3.children &&
                                        each3.render &&
                                        each3.render === "true" &&
                                        each3.serviceKey === serviceKey
                                    ) {
                                        VALUE = each3.val;

                                        this.setState({
                                            ...this.state,
                                            Give_Val_By_ServiceKey: {
                                                ...this.state.Give_Val_By_ServiceKey,
                                                [serviceKey]: each3.val,
                                            },
                                        });

                                        console.log(VALUE, "Give_Val_By_ServiceKey");

                                        if (VALUE) found = true;

                                        if (found) return VALUE;
                                    }

                                    //only for base value in billextract
                                    if (
                                        (serviceKey === "Base Value" &&
                                            each2.title === "Billing Summary") ||
                                        serviceKey === "Qty"
                                    ) {
                                        this.setState(
                                            {
                                                ...this.state,
                                                Give_Val_By_ServiceKey: {
                                                    ...this.state.Give_Val_By_ServiceKey,
                                                    [serviceKey]: [],
                                                },
                                            },
                                            () => {
                                                let arr =
                                                    this.state.Give_Val_By_ServiceKey[serviceKey] || [];

                                                if (each3.children && each3.children.length) {
                                                    each3.children.forEach((each4, m) => {
                                                        if (
                                                            !each4.children &&
                                                            each4.render &&
                                                            each4.render === "true" &&
                                                            each4.serviceKey === serviceKey
                                                        ) {
                                                            arr.push(each4.val);

                                                            if (m === each3.children.length - 1) {
                                                                found = true;
                                                                this.setState(
                                                                    {
                                                                        ...this.state,
                                                                        Give_Val_By_ServiceKey: {
                                                                            ...this.state.Give_Val_By_ServiceKey,
                                                                            [serviceKey]: arr,
                                                                        },
                                                                    },
                                                                    () =>
                                                                        console.log(
                                                                            this.state.Give_Val_By_ServiceKey[
                                                                            serviceKey
                                                                            ],
                                                                            "Give_Val_By_ServiceKey",
                                                                        ),
                                                                );

                                                                if (found) return;
                                                            }
                                                        }
                                                    });
                                                }
                                            },
                                        );
                                    }
                                });
                            }
                        });
                    }
                });
            },
        );
    };

    store_all_vals = (TREE) => {
        let VALS = this.props.storeVals ? this.props.storeVals : {};

        let TREE_ = TREE ? TREE : this.props.VR2_Form_Json;

        TREE_.forEach((each, i) => {
            if (each.children && each.children.length) {
                each.children.forEach((each2, j) => {
                    if (each2.children && each2.children.length) {
                        each2.children.forEach((each3, k) => {
                            if (!each3.children && each3.render === "true") {
                                VALS[each3.serviceID] = each3.val;
                            }

                            if (each3.children && each3.children.length) {
                                each3.children.forEach((each4, m) => {
                                    if (each4.render === "true") {
                                        VALS[each4.serviceID] = each4.val;
                                    }
                                });
                            }
                        });
                    }
                });
            }
        });

        this.props.updateStoreVals(VALS);
    };

    onClick_Validate = async (event) => {
        event.preventDefault();

        let found = false;

        //condiotional mandatory
        this.props.VR2_Form_Json?.forEach((each, i) => {
            if (found) return;

            if (each.children && each.children.length) {
                each.children.forEach((each2, j) => {
                    if (found) return;

                    if (each2.children && each2.children.length) {
                        each2.children.forEach((each3, k) => {
                            if (found) return;

                            if (
                                !each3.children &&
                                each3.mandatory &&
                                each3.mandatory === "true" &&
                                each3.render === "true" &&
                                each3.editable === "true" &&
                                !each3.val
                            ) {
                                console.log(each3.serviceID, each3);
                                document.getElementById(each3.serviceID) &&
                                    document.getElementById(each3.serviceID);
                                store.dispatch(showAlert(`${each3.serviceKey} is mandatory`, "error"));
                                found = true;
                                return;
                            }

                            if (
                                !each3.children &&
                                each3.render === "true" &&
                                each3.editable === "true" &&
                                each3.val === "Invalid date"
                            ) {
                                console.log(each3.serviceID, each3);

                                document.getElementById(each3.serviceID) &&
                                    document.getElementById(each3.serviceID);
                                store.dispatch(showAlert(`${each3.serviceKey} is mandatory`, "error"));
                                found = true;
                                return;
                            }

                            if (each3.conditional_mandatory) {
                                if (
                                    each3.conditional_mandatory.val.includes(
                                        this.props.storeVals[each3.conditional_mandatory.serviceID],
                                    ) &&
                                    each3.render === "true" &&
                                    each3.editable === "true" &&
                                    !each3.val
                                ) {
                                    console.log(each3.serviceID, each3);

                                    document.getElementById(each3.serviceID) &&
                                        document.getElementById(each3.serviceID);
                                    store.dispatch(showAlert(`${each3.serviceKey} is mandatory`, "error"));
                                    found = true;
                                    return;
                                }
                            }

                            if (each3.children && each3.children.length) {
                                each3.children.forEach((each4, m) => {
                                    if (
                                        each4.mandatory === "true" &&
                                        each4.render === "true" &&
                                        each4.editable === "true" &&
                                        !each4.val
                                    ) {
                                        console.log(each3.serviceID, each3);

                                        document.getElementById(each4.serviceID)?.focus();
                                        store.dispatch(showAlert(`${each4.serviceKey} is mandatory`, "error"));
                                        found = true;
                                        return;
                                    }

                                    if (
                                        each4.render === "true" &&
                                        each4.editable === "true" &&
                                        each4.val === "Invalid date"
                                    ) {
                                        console.log(each3.serviceID, each3);

                                        document.getElementById(each4.serviceID)?.focus();
                                        store.dispatch(showAlert(`${each4.serviceKey} is mandatory`, "error"));
                                        found = true;
                                        return;
                                    }

                                    if (each4.conditional_mandatory) {
                                        if (
                                            each4.conditional_mandatory.val.includes(
                                                this.props.storeVals[
                                                each4.conditional_mandatory.serviceID
                                                ],
                                            ) &&
                                            each4.render === "true" &&
                                            each4.editable === "true" &&
                                            !each4.val
                                        ) {
                                            console.log(each3.serviceID, each3);

                                            document.getElementById(each4.serviceID)?.focus();
                                            store.dispatch(showAlert(`${each4.serviceKey} is mandatory`, "error"));
                                            found = true;
                                            return;
                                        }
                                    }
                                });
                            }
                        });
                    }
                });
            }
        });

        //checking forprdfrom and forprdto
        this.props.VR2_Form_Json?.forEach((each, i) => {
            if (found) return;

            console.log(each, "each");

            if (each.children && each.children.length) {
                each.children.forEach((each2, j) => {
                    if (found) return;

                    if (each2.children && each2.children.length) {
                        console.log(each2, "each2");
                        each2.children.forEach((each3, row) => {
                            if (found) return;

                            let from_dt;
                            let to_dt;

                            if (each3.children && each3.children.length) {
                                each3.children.forEach((each4, m) => {
                                    if (
                                        each4.render === "true" &&
                                        (each4.serviceKey === "ForPrdFrom" ||
                                            each4.serviceKey === "ForPrdTo")
                                    ) {
                                        if (each4.serviceKey === "ForPrdFrom") from_dt = each4.val;
                                        if (each4.serviceKey === "ForPrdTo") to_dt = each4.val;

                                        if (from_dt && to_dt) {
                                            if (this.isToDateAfterFromDate(from_dt, to_dt)) {
                                            } else {
                                                console.log(
                                                    `Invalid ForPrdTo in Section "${each2.title
                                                    }" Row no ${row + 1}`,
                                                );
                                                store.dispatch(showAlert(
                                                    `Invalid ForPrdTo in Section "${each2.title
                                                    }" Row no ${row + 1}`
                                                    , "error"));
                                                found = true;
                                                return;
                                            }
                                        }
                                    }
                                });
                            } else {
                                if (
                                    this.state.token === "CostAllocationMaster" &&
                                    each3.render === "true" &&
                                    each3.serviceKey === "ForPrdFrom"
                                ) {
                                    if (each3.serviceKey === "ForPrdFrom") from_dt = each3.val;
                                    console.log(each3, from_dt, "here");

                                    if (!from_dt) {
                                        console.log(
                                            `ForPrdFrom in Section "${each2.title}" Row no ${row + 1
                                            } is mandatory`,
                                        );
                                        store.dispatch(showAlert(
                                            `ForPrdFrom in Section "${each2.title}" Row no ${row + 1
                                            } is mandatory`,
                                            "error"));
                                        found = true;
                                        return;
                                    }
                                }
                            }
                        });
                    }
                });
            }
        });

        if (this.state.token === "BillExtract") {
            // if PO/IP Type = PurchaseOrder then check all Qty is valid number or not
            await this.Give_Val_By_ServiceKey("PO/IP Type");
            let PO_IP_Type = this.state.Give_Val_By_ServiceKey?.["PO/IP Type"] || "";

            if (PO_IP_Type === "PurchaseOrder") {
                await this.Give_Val_By_ServiceKey("Qty");
                let Qty = this.state.Give_Val_By_ServiceKey?.["Qty"] || "";

                function isNumber(value) {
                    // checking number != 0 and not a number
                    return !isNaN(value) && value != 0;
                }

                const Valid = Qty.every((num) => isNumber(num));

                if (!Valid) {
                    found = true;

                    store.dispatch(showAlert(
                        `Please enter valid Qty in Billing Summary`,
                        "error"
                    ));
                    return;
                }
            }

            if (
                this.state[this.state.token] &&
                this.state[this.state.token].showSelect &&
                (this.state[this.state.token].showSelect === "GoodsReceipt" ||
                    this.state[this.state.token].showSelect === "ServiceReceipt")
            ) {
                if (
                    this.state[this.state.token] &&
                    this.state[this.state.token].select
                ) {
                } else {
                    document
                        .getElementById("FullReversal_ProportionateReversal")
                        ?.focus();
                    found = true;
                    return;
                }
            }
        }

        if (found) return;
        else {
            console.log('"hello Nothing from validate"');
            if (this.props.ORG_ID_CONST === "" || !this.props.ORG_ID_CONST) {
                if (this.state.token === "BillExtract") {
                    this.Store_ORG_ID("Organization ID");
                }
                if (this.state.token === "GoodsAndServicesEntries") {
                    this.Store_ORG_ID("Receiver ID");
                }
            }
            this.setState({ showSpinner: true }, async () => {
                let Input = {
                    TREE_JSON: this.props.VR2_Form_Json,
                    ORG_ID_CONST:
                        this.props.ORG_ID_CONST ||
                        (this.state.token === "BillExtract" &&
                            this.state.Give_Val_By_ServiceKey?.["Organization ID"]) ||
                        (this.state.token === "GoodsAndServicesEntries" &&
                            this.state.Give_Val_By_ServiceKey?.["Receiver ID"]),
                };

                if (this.state.token === "BillExtract") {
                    await this.Give_Val_By_ServiceKey("DocumentType");
                    let DocumentType =
                        this.state.Give_Val_By_ServiceKey?.["DocumentType"] || "";
                    await this.Give_Val_By_ServiceKey("Base Value");
                    let BaseValue =
                        this.state.Give_Val_By_ServiceKey?.["Base Value"] || "";
                    await this.Give_Val_By_ServiceKey("ExchangeRate");
                    let ExchangeRate =
                        this.state.Give_Val_By_ServiceKey?.["ExchangeRate"] || "";
                    await this.Give_Val_By_ServiceKey("Original Invoice Ref");
                    let OriginalInvoiceRef =
                        this.state.Give_Val_By_ServiceKey?.["Original Invoice Ref"] || "";

                    await this.Give_Val_By_ServiceKey("Invoice Ref");
                    let InvoiceRef =
                        this.state.Give_Val_By_ServiceKey?.["Invoice Ref"] || "";
                    await this.Give_Val_By_ServiceKey("Vendor ID");
                    let VendorID = this.state.Give_Val_By_ServiceKey?.["Vendor ID"] || "";
                    await this.Give_Val_By_ServiceKey("Bill Number");
                    let BillNumber =
                        this.state.Give_Val_By_ServiceKey?.["Bill Number"] || "";

                    // BaseValue is a array ['543', '293.93'] - sum the all numbers
                    const sum = BaseValue.reduce((accumulator, currentValue) => {
                        const number = Number(currentValue);
                        return accumulator + number;
                    }, 0);
                    console.log(sum);

                    Input = {
                        ...Input,
                        DocumentType,
                        BaseValue: sum,
                        ExchangeRate,
                        OriginalInvoiceRef,
                        InvoiceRef,
                        VendorID,
                        BillNumber,
                    };
                }

                if (this.state.token === "VendorMaster") {
                    await this.Give_Val_By_ServiceKey("Vendor ID");
                    let VendorID = this.state.Give_Val_By_ServiceKey?.["Vendor ID"] || JSON.parse(localStorage.getItem("selectedItem") || "{}")?.id || "";
                    await this.Give_Val_By_ServiceKey("Vendor Name");
                    let VendorName =
                        this.state.Give_Val_By_ServiceKey?.["Vendor Name"] || "";
                    await this.Give_Val_By_ServiceKey("PAN");
                    let PAN = this.state.Give_Val_By_ServiceKey?.["PAN"] || "";

                    Input = {
                        ...Input,
                        VendorID: VendorID || JSON.parse(localStorage.getItem("selectedItem") || "{}")?.id || "",
                        VendorName,
                        PAN,
                    };
                }
                postRequest(
                    `api/vr2/validateDocuments?module=${localStorage.getItem(
                        "module",
                    )}&screenName=${this.state.token}`,
                    Input,
                ).then(async (res) => {
                    this.setState({ showSpinner: false });

                    if (
                        res.res.status === "success" &&
                        this.state.token === "BillExtract"
                    ) {
                        const { data, key } = res.res.data
                        try {
                            let { res } = await getRequest(
                                `api/edureka/getJSONViaKey?docId=${this.props.docId}&companyid=${this.props.ORG_ID_CONST}&key=${key || ''}`,
                            );
                            if (res.status === "success") {
                                this.props.handleTreeChange(res.data);
                            }
                            return;
                        } catch (error) {
                            console.log(error);
                        }
                    } else if (res.res.status === "success") {
                        this.props.handleTreeChange(res.res.data);
                    } else if (res.res.status === "info") {
                        let ok = (
                            <Popup
                                noClose={true}
                                content={
                                    <>
                                        <div className="mt-3 mb-3" align="center">
                                            <div>{res.res.data}</div>
                                        </div>

                                        <div align="center">
                                            <button
                                                onClick={() =>
                                                    this.setState({ confirmationToActivate: null })
                                                }
                                                className="btn btn-warning btn-sm ml-1"
                                            >
                                                Ok
                                            </button>
                                        </div>
                                    </>
                                }
                            />
                        );

                        this.setState({ confirmationToActivate: ok });
                    }
                });
            });
        }
    };

    TopErrAlert = (msg) => {
        this.setState({
            alert: (
                <Snackbar
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                    open={true}
                    autoHideDuration={10000}
                    onClose={() => this.setState({ ...this.state, alert: null })}
                >
                    <Alert
                        onClose={() => this.setState({ ...this.state, alert: null })}
                        severity={"error"}
                        variant="filled"
                        sx={{ width: "100%" }}
                    >
                        {msg}
                    </Alert>
                </Snackbar>
            ),
        });
    };

    isToDateAfterFromDate = (fromDate, toDate) => {
        // Convert "DD-MM-YYYY" string dates to Date objects
        if (!fromDate || !toDate) return false;
        const [fromDay, fromMonth, fromYear] = fromDate?.includes("-")
            ? fromDate.split("-")
            : fromDate.split("/");
        const fromDateObj = new Date(`${fromYear}-${fromMonth}-${fromDay}`);

        const [toDay, toMonth, toYear] = toDate.includes("-")
            ? toDate.split("-")
            : toDate.split("/");
        const toDateObj = new Date(`${toYear}-${toMonth}-${toDay}`);

        // Compare the dates
        return toDateObj >= fromDateObj;
    };

    onClick_Activate = async (event, dont_stop = this.state.rejectionStatus) => {
        event.preventDefault();
        console.log(this.props.storeVals);

        let found = false;
        let stop = false;
        let stop_2 = false;
        let stop_3 = false;
        let stopAll = false;
        //condiotional mandatory
        this.props.VR2_Form_Json?.forEach((each, i) => {
            if (found) return;

            if (each.children && each.children.length) {
                each.children.forEach((each2, j) => {
                    if (found) return;

                    if (each2.children && each2.children.length) {
                        each2.children.forEach((each3, k) => {
                            if (found) return;

                            if (
                                !each3.children &&
                                each3.mandatory &&
                                each3.mandatory === "true" &&
                                each3.render === "true" &&
                                each3.editable === "true" &&
                                !each3.val
                            ) {
                                console.log(each3.serviceID);
                                document.getElementById(each3.serviceID) &&
                                    document.getElementById(each3.serviceID);
                                store.dispatch(showAlert(`${each3.serviceKey} is mandatory`, "error"));
                                found = true;
                                return;
                            }

                            if (each3.conditional_mandatory) {
                                // console.log(each3)
                                // console.log(each3.conditional_mandatory)
                                // console.log(this.props.storeVals[each3.conditional_mandatory.serviceID])

                                if (
                                    each3.conditional_mandatory.val.includes(
                                        this.props.storeVals[each3.conditional_mandatory.serviceID],
                                    ) &&
                                    each3.render === "true" &&
                                    each3.editable === "true" &&
                                    !each3.val
                                ) {
                                    console.log(each3.serviceID, '"helohelo321"');
                                    document.getElementById(each3.serviceID) &&
                                        document.getElementById(each3.serviceID);
                                    store.dispatch(showAlert(`${each3.serviceKey} is mandatory`, "error"));
                                    found = true;
                                    return;
                                }
                            }

                            if (each3.children && each3.children.length) {
                                each3.children.forEach((each4, m) => {
                                    if (
                                        each4.mandatory === "true" &&
                                        each4.render === "true" &&
                                        each4.editable === "true" &&
                                        !each4.val
                                    ) {
                                        console.log(each4.serviceID);
                                        document.getElementById(each4.serviceID)?.focus();
                                        store.dispatch(showAlert(`${each4.serviceKey} is mandatory`, "error"));
                                        found = true;
                                        return;
                                    }

                                    if (each4.conditional_mandatory) {
                                        if (
                                            each4.conditional_mandatory.val.includes(
                                                this.props.storeVals[
                                                each4.conditional_mandatory.serviceID
                                                ],
                                            ) &&
                                            each4.render === "true" &&
                                            each4.editable === "true" &&
                                            !each4.val
                                        ) {
                                            console.log(each4.serviceID, '"helohelo123"');
                                            document.getElementById(each4.serviceID)?.focus();
                                            store.dispatch(showAlert(`${each4.serviceKey} is mandatory`, "error"));
                                            found = true;
                                            return;
                                        }
                                    }
                                });
                            }
                        });
                    }
                });
            }
        });

        //checking forprdfrom and forprdto
        this.props.VR2_Form_Json?.forEach((each, i) => {
            if (found) return;

            if (each.children && each.children.length) {
                each.children.forEach((each2, j) => {
                    if (found) return;

                    if (each2.children && each2.children.length) {
                        each2.children.forEach((each3, row) => {
                            if (found) return;

                            let from_dt;
                            let to_dt;

                            if (each3.children && each3.children.length) {
                                each3.children.forEach((each4, m) => {
                                    if (
                                        each4.render === "true" &&
                                        (each4.serviceKey === "ForPrdFrom" ||
                                            each4.serviceKey === "ForPrdTo")
                                    ) {
                                        if (each4.serviceKey === "ForPrdFrom") from_dt = each4.val;
                                        if (each4.serviceKey === "ForPrdTo") to_dt = each4.val;

                                        if (from_dt && to_dt) {
                                            if (this.isToDateAfterFromDate(from_dt, to_dt)) {
                                            } else {
                                                console.log(
                                                    `Invalid ForPrdTo in Section "${each2.title
                                                    }" Row no ${row + 1}`,
                                                );
                                                store.dispatch(showAlert(
                                                    `Invalid ForPrdTo in Section "${each2.title
                                                    }" Row no ${row + 1}`,
                                                ), "error");
                                                found = true;
                                                return;
                                            }
                                        }
                                    }
                                });
                            }
                        });
                    }
                });
            }
        });

        if (this.state.token === "BillExtract") {
            // if PO/IP Type = PurchaseOrder then check all Qty is valid number or not
            await this.Give_Val_By_ServiceKey("PO/IP Type");
            let PO_IP_Type = this.state.Give_Val_By_ServiceKey?.["PO/IP Type"] || "";
            console.log(PO_IP_Type);

            if (PO_IP_Type === "PurchaseOrder") {
                await this.Give_Val_By_ServiceKey("Qty");
                let Qty = this.state.Give_Val_By_ServiceKey?.["Qty"] || "";
                console.log(Qty);

                function isNumber(value) {
                    // checking number != 0 and not a number
                    return !isNaN(value) && value != 0;
                }

                const Valid = Qty.every((num) => isNumber(num));

                if (!Valid) {
                    found = true;

                    store.dispatch(showAlert(`Please enter valid Qty in Billing Summary`, "error"));
                    return;
                }
            }

            if (
                this.state[this.state.token] &&
                this.state[this.state.token].showSelect &&
                (this.state[this.state.token].showSelect === "GoodsReceipt" ||
                    this.state[this.state.token].showSelect === "ServiceReceipt")
            ) {
                if (
                    this.state[this.state.token] &&
                    this.state[this.state.token].select
                ) {
                } else {
                    document
                        .getElementById("FullReversal_ProportionateReversal")
                        ?.focus();
                    found = true;
                    return;
                }
            }
        }

        if (found) return;
        else {
            let Input = {
                TREE_JSON: this.props.VR2_Form_Json,
                ORG_ID_CONST: this.props.ORG_ID_CONST,
                OldAccountingDate: this.state.OldAccountingDate,
                isForRejection: this.state.rejectorApprovalStatus,
            };

            if (this.state.token === "ItemMaster") {
                await this.Give_Val_By_ServiceKey("Item ID");
                let ItemID = this.state.Give_Val_By_ServiceKey?.["Item ID"] || "";
                await this.Give_Val_By_ServiceKey("Item Name");
                let ItemName = this.state.Give_Val_By_ServiceKey?.["Item Name"] || "";

                Input = {
                    ...Input,
                    ItemID,
                    ItemName,
                };
                console.log(Input);
            }

            if (this.state.token === "VendorMaster" || this.state.token === "VendorRegistration") {
                await this.Give_Val_By_ServiceKey("Vendor ID");
                let VendorID = this.state.Give_Val_By_ServiceKey?.["Vendor ID"] || "";
                await this.Give_Val_By_ServiceKey("Vendor Name");
                let VendorName =
                    this.state.Give_Val_By_ServiceKey?.["Vendor Name"] || "";

                let ActivityStatus = Object.keys(this.props.storeVals).filter((key) => key.includes("vendormasterworkflow#activitystatus"))
                    .map((key) => this.props.storeVals[key]).filter(val => val != '');

                let Reason = Object.keys(this.props.storeVals)
                    .filter((key) => key.includes("vendormasterworkflow#reason"))
                    .map((key) => this.props.storeVals[key]).filter(val => val != '');
                let isForApproved = ActivityStatus.every(value => value === "Approved");
                let isForReject = ActivityStatus.some(value => value === "Rejected");
                let isForWaitingforApproval = ActivityStatus.every(value => value === "");

                Input = {
                    ...Input,
                    VendorID: VendorID || JSON.parse(localStorage.getItem("selectedItem")).id,
                    VendorName,
                    ActivityStatus: isForApproved ? "APPROVED"
                        : isForReject ? "REJECTED"
                            : isForWaitingforApproval ? "WAITING FOR APPROVAL" : '',
                    Reason: isForReject && Array.isArray(Reason) && Reason.length > 1 ? Reason.join(", ") : Reason.length === 1 ? Reason[0] : Reason,
                    EmailID: JSON.parse(localStorage.getItem("selectedItem")).emailid
                };
                console.log(Input);
            }

            if (this.state.token === "CostAllocationMaster") {
                await this.Give_Val_By_ServiceKey("Cost Allocation Method");
                let CostAllocationMethod =
                    this.state.Give_Val_By_ServiceKey?.["Cost Allocation Method"] || "";
                await this.Give_Val_By_ServiceKey("ForPrdFrom");
                let ForPrdFrom =
                    this.state.Give_Val_By_ServiceKey?.["ForPrdFrom"] || "";
                await this.Give_Val_By_ServiceKey("ForPrdTo");
                let ForPrdTo = this.state.Give_Val_By_ServiceKey?.["ForPrdTo"] || "";

                Input = {
                    ...Input,
                    CostAllocationMethod,
                    ForPrdFrom,
                    ForPrdTo,
                };
                console.log(Input);
            }

            if (this.state.token === "BillExtract") {
                await this.Give_Val_By_ServiceKey("Invoice Ref");
                let InvoiceRef =
                    this.state.Give_Val_By_ServiceKey?.["Invoice Ref"] || "";
                await this.Give_Val_By_ServiceKey("Vendor ID");
                let VendorID = this.state.Give_Val_By_ServiceKey?.["Vendor ID"] || "";
                await this.Give_Val_By_ServiceKey("Bill Number");
                let BillNumber =
                    this.state.Give_Val_By_ServiceKey?.["Bill Number"] || "";

                Input = {
                    ...Input,
                    InvoiceRef,
                    VendorID,
                    BillNumber,
                };
                console.log(Input);

                // checking cost allocation CostAllocated Lcl Curr is not empty
                this.props.VR2_Form_Json?.forEach((each, i) => {
                    if (found) return;
                    if (each.children && each.children.length) {
                        each.children.forEach((each2, j) => {
                            if (found) return;
                            if (each2.children && each2.children.length) {
                                if (each2.title === "Bill Cost Allocation") {
                                    each2.children.forEach((each3, k) => {
                                        if (each3.children && each3.children.length) {
                                            each3.children.forEach((each4, m) => {
                                                let CostAllocatedLclCurr = [];

                                                if (each4.title === "CostAllocated Lcl Curr") {
                                                    CostAllocatedLclCurr.push(each4.val);

                                                    if (m === each3.children.length - 1) {
                                                        const sum = CostAllocatedLclCurr.reduce(
                                                            (accumulator, currentValue) => {
                                                                const number = Number(currentValue);
                                                                return accumulator + number;
                                                            },
                                                            0,
                                                        );
                                                        console.log(sum);

                                                        if (!sum || isNaN(sum)) {
                                                            stop = true;

                                                            store.dispatch(showAlert(
                                                                `Cost Allocation is not defined! Please don't activate`,
                                                                "error"));
                                                        }
                                                    }
                                                }
                                            });
                                        }
                                    });
                                }
                            }
                        });
                    }
                });

                // 0 Value check Col - CostAllocationVariance, AJCrossFootErrorInd, ReversedAJCrossFootErrorInd
                this.store_all_vals();

                let SerIDS = [
                    "costallocationvariance",
                    "ajcrossfooterrorind",
                    "reversedajcrossfooterrorind",
                ];

                SerIDS = SerIDS?.map((each) => this.trim(each)) || [];

                let storeVals = this.props.storeVals;

                let obj = {};

                Object.keys(storeVals).forEach((each) => {
                    let key = each.split("#")[1];

                    if (SerIDS.includes(key)) {
                        if (!obj[key]) obj[key] = storeVals[each];
                    }
                });

                console.log(obj); //////////// roundoff

                if (
                    Math.round(obj.costallocationvariance) == 0 &&
                    Math.round(obj.ajcrossfooterrorind) == 0 &&
                    (Math.round(obj.reversedajcrossfooterrorind) == 0 ||
                        !obj.reversedajcrossfooterrorind)
                ) {
                } else {
                    stop_2 = true;

                    store.dispatch(showAlert(
                        `Bill Cost Error Detection Table Error! Please don't activate`,
                    ), "error");
                }
                //Expenses Journal checking LedgerName and AccountCode is not empty
                this.props.VR2_Form_Json?.forEach((each, i) => {
                    if (found) return;
                    if (each.children && each.children.length) {
                        each.children.forEach((each2, j) => {
                            if (found) return;
                            if (each2.children && each2.children.length) {
                                if (found) return;
                                if (
                                    (each2.title === "Billing Summary" && !dont_stop) ||
                                    (each2.title === "Two Way Matching(Bill Vs PO/IP)" &&
                                        !stopAll &&
                                        !dont_stop)
                                ) {
                                    let Qty = {
                                        "Balance in PO/IP": 0,
                                        Bill: 0,
                                        Difference: 0,
                                    };
                                    let Rate = {
                                        "Balance in PO/IP": 0,
                                        Bill: 0,
                                        Difference: 0,
                                    };
                                    let BaseValue = {
                                        "Balance in PO/IP": 0,
                                        Bill: 0,
                                        Difference: 0,
                                    };
                                    each2.children.forEach((each3, k) => {
                                        if (each3.children && each3.children.length) {
                                            let Field;
                                            each3.children.forEach((each4, m) => {
                                                if (
                                                    each4.title === "Fields" &&
                                                    (each4.val === "Qty" ||
                                                        each4.val === "BaseValue" ||
                                                        each4.val === "Rate")
                                                ) {
                                                    Field = each4.val;
                                                }

                                                if (
                                                    Field == "BaseValue" &&
                                                    (each4.title == "Balance in PO/IP" ||
                                                        each4.title == "Bill" ||
                                                        each4.title == "Difference")
                                                ) {
                                                    BaseValue = {
                                                        ...BaseValue,
                                                        [each4.title]: each4.val.includes("-")
                                                            ? parseInt(each4.val.replace("-", ""))
                                                            : parseInt(each4.val),
                                                    };
                                                }

                                                if (
                                                    Field == "Rate" &&
                                                    (each4.title == "Balance in PO/IP" ||
                                                        each4.title == "Bill" ||
                                                        each4.title == "Difference")
                                                ) {
                                                    Rate = {
                                                        ...Rate,
                                                        [each4.title]: each4.val.includes("-")
                                                            ? parseInt(each4.val.replace("-", ""))
                                                            : parseInt(each4.val),
                                                    };
                                                }

                                                if (
                                                    Field == "Qty" &&
                                                    (each4.title == "Balance in PO/IP" ||
                                                        each4.title == "Bill" ||
                                                        each4.title == "Difference")
                                                ) {
                                                    console.log(each4);

                                                    Qty = {
                                                        ...Qty,
                                                        [each4.title]: each4.val.includes("-")
                                                            ? parseInt(each4.val.replace("-", ""))
                                                            : parseInt(each4.val),
                                                    };
                                                }
                                                console.log(
                                                    BaseValue.Difference,
                                                    Qty.Difference,
                                                    Rate.Difference,
                                                    each2.title === "Two Way Matching(Bill Vs PO/IP)" &&
                                                    (BaseValue.Difference !== 0 ||
                                                        Qty.Difference !== 0 ||
                                                        Rate.Difference !== 0),
                                                    each2.title === "Billing Summary" &&
                                                    each4.title === "Order ID" &&
                                                    each4.val === "",
                                                );

                                                if (
                                                    (each2.title === "Billing Summary" &&
                                                        each4.title === "Order ID" &&
                                                        each4.val === "") ||
                                                    (each2.title === "Two Way Matching(Bill Vs PO/IP)" &&
                                                        (BaseValue.Difference !== 0 ||
                                                            Qty.Difference !== 0 ||
                                                            Rate.Difference !== 0))
                                                ) {
                                                    stopAll = true;

                                                    this.setState({
                                                        DialougeBox: (
                                                            <DialougeBox
                                                                status={"error"}
                                                                onClose={() =>
                                                                    this.setState({ DialougeBox: null })
                                                                }
                                                                message={`• Discrepancy Detected in Rate/Quantity/Base Value. 
• Please verify Two-Way Matching between Bill and PO/IP.
                        ( OR ) 
 Do you want to proceed without mapping a Goods & Services Entry (GSE)?
                                 `}
                                                                operation={() => {
                                                                    this.setState({
                                                                        DialougeBox: (
                                                                            <DialougeBox
                                                                                status={"warning"}
                                                                                onClose={() =>
                                                                                    this.setState({ DialougeBox: null })
                                                                                }
                                                                                message={`• You are proceeding without a mapped Goods & Services Entry (GSE) for this bill. GSE may not be applicable for certain items such as:
   – Electricity, Water Tax, Property Tax, Internet, Salaries, Fuel, etc.
• Please ensure this bill falls under such exempted categories.
• If not, review and map the appropriate GSE.
• Reconfirmation Needed:   Do you want to continue without Goods & Services Entry?`}
                                                                                operation={(e) => {
                                                                                    this.onClick_Activate(e, true);
                                                                                    this.setState({ DialougeBox: null });
                                                                                }}
                                                                            />
                                                                        ),
                                                                    });
                                                                }}
                                                            />
                                                        ),
                                                    });
                                                    return;
                                                }
                                            });
                                        }
                                    });
                                }
                                if (each2.title === "Expenses Journal") {
                                    each2.children.forEach((each3, k) => {
                                        if (each3.children && each3.children.length) {
                                            let AccountType;
                                            each3.children.forEach((each4, m) => {
                                                let errMsg;
                                                if (each4.title === "AccountType")
                                                    AccountType = each4.val;

                                                if (
                                                    AccountType &&
                                                    AccountType === "CreditorsAc" &&
                                                    each4.title === "SubLedgerName"
                                                ) {
                                                    if (!each4.val)
                                                        errMsg = `${each4.title} is empty in Expenses Journal`;
                                                }
                                                if (
                                                    each4.title === "AccountingDate" ||
                                                    each4.title === "AccountType" ||
                                                    each4.title === "ItemType" ||
                                                    each4.title === "LedgerName"
                                                ) {
                                                    if (!each4.val)
                                                        errMsg = `${each4.title} is empty in Expenses Journal`;
                                                }
                                                if (each4.title === "AccountCode") {
                                                    if (
                                                        !each4.val ||
                                                        each4.val === "null" ||
                                                        each4.val === "0" ||
                                                        each4.val === "0.0"
                                                    ) {
                                                        errMsg = `${each4.title} is not valid in Expenses Journal`;
                                                    }
                                                }
                                                if (errMsg) {
                                                    found = true;
                                                    stop_3 = true;

                                                    store.dispatch(showAlert(errMsg, "error"));
                                                }
                                            });
                                        }
                                    });
                                }
                            }
                        });
                    }
                });
            }

            !stopAll &&
                !stop &&
                !stop_2 &&
                !stop_3 &&
                this.setState({ showSpinner: true }, () => {
                    console.log('"hello Nothing from active"');
                    if (this.state.ReferenceName) {
                        this.DeleteDraft();
                    }
                    postRequest(
                        `api/vr2/UpdateDocuments?module=${localStorage.getItem(
                            "module",
                        )}&screenName=${this.state.token}&context=${this.props.screenAction === "PartialCreate"
                            ? "create"
                            : this.props.screenAction
                        }`,
                        Input,
                    ).then((res) => {
                        this.setState({ showSpinner: false });
                        if (res.res.status === "success") {
                            console.log(res.res.data);
                            if (this.props.screenAction !== "create") {
                                setTimeout(() => {
                                    window.close();
                                }, 1000);
                            } else {
                                this.props.onBack();
                            }
                        }
                        if (res.res.status === "info") {
                            if (this.props.screenAction === "edit") {
                                window.close();
                            }
                            let ok = (
                                <DialougeBox
                                    status={"info"}
                                    onClose={() => this.setState({ DialougeBox: null })}
                                    message={res.res.data.message}
                                    operation={() => {
                                        this.Give_Val_By_ServiceKey("Organization Name");
                                        this.handleExtend(
                                            res.res.data.ID,
                                            res.res.data.Name,
                                            this.props.VR2_Form_Json,
                                        );
                                    }}
                                />
                            );

                            this.setState({ DialougeBox: ok });
                        }
                    });
                });
        }
    };

    trim = (str) => {
        return str.replace(/\s+/g, "").toLowerCase();
    };

    confirmationToActivate = (e) => {
        e.preventDefault();

        this.setState({ showSpinner: true }, () => {
            postRequest(
                `api/vr2/UpdateDocuments?proceed=true&module=${localStorage.getItem(
                    "module",
                )}&screenName=${this.state.token}&context=${this.props.screenAction === "PartialCreate"
                    ? "create"
                    : this.props.screenAction
                }`,
                {
                    TREE_JSON: this.props.VR2_Form_Json,
                },
            ).then((res) => {
                if (res.res.status === "success") {
                    console.log(res.res.data);
                }

                this.setState({ showSpinner: false });

                setTimeout(() => {
                    // window.location.reload()
                    this.props.onBack();
                }, 1000);
            });
        });
    };

    rerender = (noQuit) => {
        let canQuit = this.state.canQuit;
        this.setState(
            {
                time: new Date(),
                canQuit: noQuit ? false : canQuit,
            },
            () => console.log("cr7"),
        );
    };

    setRejectorApprovalStatus = (status) => {
        this.setState({ rejectorApprovalStatus: status });
    };

    Store_ORG_ID = async (FROM) => {
        await this.Give_Val_By_ServiceKey(FROM);

        const lookup = this.state?.Give_Val_By_ServiceKey || {};
        const val = lookup[FROM];

        if (val) {
            this.props.Set_ORG_ID_CONST(val);
        } else {
            console.warn(`Store_ORG_ID: No value found for ${FROM}`);
        }
    };

    putDefaultValue_BillExtract_copyFrom = async (TO, FROM) => {
        await this.Give_Val_By_ServiceKey(FROM);

        const lookup = this.state?.Give_Val_By_ServiceKey || {};
        const val = lookup[FROM];

        if (val) {
            this.putDefaultValue_BillExtract(TO, val);
        } else {
            console.warn(
                `putDefaultValue_BillExtract_copyFrom: No value found for ${FROM}`,
            );
        }
    };

    putDefaultValue_BillExtract = (KEY, VAL) => {
        console.log(KEY, VAL);

        let VR2_Form_Json = this.props.VR2_Form_Json;
        console.log(VR2_Form_Json);
        let found = false;

        VR2_Form_Json?.forEach((each, i) => {
            if (found) return;
            if (each.children && each.children.length) {
                each.children.forEach((each2, j) => {
                    if (found) return;
                    if (each2.children && each2.children.length) {
                        each2.children.forEach((each3, k) => {
                            if (found) return;

                            if (
                                !each3.children &&
                                each3.render &&
                                each3.render === "true" &&
                                each3.serviceKey === KEY
                            ) {
                                if (!each3.val) {
                                    each3.val = VAL;
                                    this.props.handleTreeChange(VR2_Form_Json);
                                }

                                found = true;
                                return;
                            }
                        });
                    }
                });
            }
        });
    };

    getTDSAsExp = (KEY, stateKey, render) => {
        console.log(KEY, stateKey);

        let VR2_Form_Json = this.props.VR2_Form_Json;
        let found = false;

        VR2_Form_Json?.forEach((each, i) => {
            if (found) return;
            if (each.children && each.children.length) {
                each.children.forEach((each2, j) => {
                    if (found) return;
                    if (each2.children && each2.children.length) {
                        each2.children.forEach((each3, k) => {
                            if (found) return;

                            if (
                                render &&
                                !each3.children &&
                                each3.render &&
                                each3.render === "true" &&
                                each3.serviceKey === KEY
                            ) {
                                this.setState(
                                    {
                                        ...this.state,
                                        [this.state.token]: {
                                            ...this.state[this.state.token],
                                            [stateKey]: each3.val,
                                        },
                                    },
                                    () => console.log(this.state),
                                );
                                found = true;
                                return;
                            } else if (
                                !each3.children &&
                                each3.render &&
                                each3.render === "false" &&
                                each3.serviceKey === KEY
                            ) {
                                this.setState(
                                    {
                                        ...this.state,
                                        [this.state.token]: {
                                            ...this.state[this.state.token],
                                            [stateKey]: each3.val,
                                        },
                                    },
                                    () => console.log(this.state),
                                );
                                found = true;
                                return;
                            }
                        });
                    }
                });
            }
        });
    };

    TDSAsExp = (KEY, VAL, stateKey) => {
        let serviceKey = KEY;
        let storeVal = VAL;

        let VR2_Form_Json = this.props.VR2_Form_Json;
        console.log(VR2_Form_Json);
        let found = false;

        VR2_Form_Json?.forEach((each, i) => {
            if (found) return;
            if (each.children && each.children.length) {
                each.children.forEach((each2, j) => {
                    if (found) return;
                    if (each2.children && each2.children.length) {
                        each2.children.forEach((each3, k) => {
                            if (found) return;

                            if (
                                !each3.children &&
                                each3.render &&
                                each3.render === "false" &&
                                each3.serviceKey === serviceKey
                            ) {
                                if (stateKey === "select" || !each3.val) {
                                    each3.val = storeVal;
                                } else if (each3.val) {
                                    each3.val = "";
                                    storeVal = "";
                                }

                                // found = true
                                this.props.handleTreeChange(VR2_Form_Json);

                                this.setState(
                                    {
                                        ...this.state,
                                        [this.state.token]: {
                                            ...this.state[this.state.token],
                                            [stateKey]: storeVal,
                                        },
                                    },
                                    () => console.log(this.state),
                                );

                                return;
                            }
                        });
                    }
                });
            }
        });
    };

    onClickBack = () => {
        if (this.state.canQuit) {
            this.props.onBack();
        } else {
            this.setState({
                DialougeBox: (
                    <DialougeBox
                        status={"warning"}
                        onClose={() => this.setState({ DialougeBox: null })}
                        message={
                            <>
                                <Typography>
                                    {" "}
                                    If you go back, you will lose your changes. Are you sure ?
                                    (or) save as draft
                                    <IconButton
                                        color="success"
                                        style={{ border: "none", fontSize: "large" }}
                                        onClick={() => {
                                            !this.state.ReferenceName
                                                ? this.setState({
                                                    DialougeBox: (
                                                        <DialougeBox
                                                            onClose={() =>
                                                                this.setState({
                                                                    DialougeBox: null,
                                                                    ReferenceName: null,
                                                                })
                                                            }
                                                            title={"To save Draft set a Reference Name"}
                                                            message={
                                                                <>
                                                                    <TextField
                                                                        autoFocus
                                                                        required
                                                                        margin="dense"
                                                                        id="name"
                                                                        name="Refrence name"
                                                                        label="Refrence name"
                                                                        type="text"
                                                                        fullWidth
                                                                        variant="outlined"
                                                                        onChange={(e) =>
                                                                            this.setState({
                                                                                ReferenceName: e.target.value,
                                                                            })
                                                                        }
                                                                    />
                                                                </>
                                                            }
                                                            operation={this.SaveDraft()}
                                                        />
                                                    ),
                                                })
                                                : this.SaveDraft(true);
                                        }}
                                    >
                                        <SaveAsRoundedIcon />
                                    </IconButton>
                                </Typography>
                            </>
                        }
                        operation={() => this.props.onBack()}
                    />
                ),
            });
        }
    };

    toParent = (input) => {
        this.setState(
            {
                ...this.state,
                [this.state.token]: {
                    ...this.state[this.state.token],
                    showSelect: input,
                },
            },
            () => console.log(this.state),
        );
    };

    scrollToBottom = () => {
        if (this.containerRef.current) {
            this.containerRef.current.scrollTo({
                top: this.containerRef.current.scrollHeight,
                behavior: "smooth",
            });
        }
    };

    scrollToTop = () => {
        if (this.containerRef.current) {
            this.containerRef.current.scrollTo({
                top: 0,
                behavior: "smooth",
            });
        }
    };

    handleScroll = () => {
        const isAtBottom =
            window.innerHeight + window.scrollY >= document.body.offsetHeight;

        this.setState({ showScrollButton: isAtBottom });
    };
    handleReExtract = () => {
        try {
            let response = postRequest(
                "api/edureka/handleReExtraction",
                {
                    item: JSON.parse(localStorage.getItem("selectedItem")),
                    orgid: this.props.ORG_ID_CONST,
                    orgname: localStorage.getItem("orgName"),
                },
                1000000,
            );
            this.setState({ DialougeBox: null });
            Window.close();
        } catch (error) {
            console.log(error);
        } finally {
            localStorage.removeItem("selectedItem");
            localStorage.removeItem("OrgName");
        }
    };

    handleSendChangesEmail = () => {
        const emailTo = this.state.changesEmailTo;
        const selectedItem = JSON.parse(localStorage.getItem("selectedItem") || "{}");
        const vendorId = selectedItem['id'] || selectedItem['Vendor ID'] || "";

        let customMessage = "[Type your message to the vendor here]";
        let fullHtml = "";

        if (this.emailContentRef.current) {
            const adminMsgElement = this.emailContentRef.current.querySelector('#admin-message-content');
            if (adminMsgElement) {
                customMessage = adminMsgElement.innerText || adminMsgElement.textContent;
            }
            fullHtml = `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <title>Request for Changes</title>
</head>
<body style="margin: 0; padding: 40px 20px; background: linear-gradient(135deg, #e0f2fe 0%, #f0fdf4 100%); font-family: sans-serif;">
    <div style="max-width: 650px; margin: 0 auto; background-color: #ffffff; border-radius: 16px; overflow: hidden; box-shadow: 0 10px 40px rgba(0, 31, 63, 0.08); border: 1px solid rgba(135, 206, 235, 0.2);">
        ${this.emailContentRef.current.innerHTML}
    </div>
</body>
</html>`;
        }

        // Assuming you have an API to send the email or you want to use the same logic as handleReExtract with an email payload.
        // For now, making a postRequest with the email contents.
        this.setState({ showSpinner: true });
        postRequest("api/vr2/sendRequestChangesEmail", {
            email: emailTo,
            subject: "Action Required: Request for Changes",
            message: fullHtml,
            customMessage: customMessage,
            id: vendorId,
            vendorname: selectedItem['vendor_name'] || 'Vendor',
            orgid: this.props.ORG_ID_CONST || localStorage.getItem('tenant_id')
        }).then(res => {
            console.log(res);
        }).catch(err => {
            console.error(err);
        }).finally(() => {
            this.setState({ showSpinner: false, openChangesEmailDialog: false });
        });
    };

    SaveDraft = async (alreadyExist = "false") => {
        try {
            if (this.state.ReferenceName) {
                this.setState({ showSpinner: true });
                const response = await postRequest(
                    `api/vr2/saveDraft?&orgId=${this.props.ORG_ID_CONST}&screenName=${this.props.screenName}&ReferenceName=${this.state.ReferenceName}&alreadyExist=${alreadyExist}`,
                    { json: this.props.VR2_Form_Json },
                );
                if (response.res.status === "success") {
                    this.setState({ DialougeBox: null });
                    this.setState({ canQuit: true });
                    return;
                }
                this.setState({ ReferenceName: null, DialougeBox: null });
            }
        } catch (error) {
            console.log(error);
        } finally {
            this.setState({ showSpinner: false });
        }
    };

    DeleteDraft = async () => {
        try {
            this.setState({ showSpinner: true });
            const response = await postRequest(
                `api/vr2/deleteDraft?&orgId=${this.props.ORG_ID_CONST}&screenName=${this.props.screenName}&ReferenceName=${this.state.ReferenceName}`,
            );
            if (response.res.status === "success") {
                this.setState({ DialougeBox: null, ReferenceName: null });
            }
        } catch (error) {
            console.log(error);
        } finally {
            this.setState({ showSpinner: false });
        }
    };


    render() {
        if (
            Array.isArray(this.props.VR2_Form_Json) &&
            (this.state.render ||
                this.props.screenAction === "edit" ||
                this.props.screenAction === "draft") &&
            this.props.VR2_Form_Json &&
            this.props.dependency_json
        ) {
            return (
                <div className="row" style={{ height: "90vh", width: "100%" }}>
                    {this.state.showpopup ? (
                        <ValidatePopUp
                            show={this.state.showpopup}
                            message={this.state.message}
                            handleClose={this.handleClose}
                        />
                    ) : null}

                    {
                        this.state.popup_table && (
                            <Popup
                                title={"3 Way Matching Review"}
                                content={
                                    <>
                                        <div className="row m-4">
                                            {!this.state.popup_table
                                                .filteredData
                                                ?.length ? (
                                                <div>
                                                    No match found
                                                </div>
                                            ) : (
                                                <TableContainer component={Paper} style={{ maxHeight: '60vh' }}>
                                                    <Table stickyHeader size="small">
                                                        <TableHead>
                                                            <TableRow>
                                                                {this.state.popup_table.header?.map(
                                                                    (each, indx) => {
                                                                        return (
                                                                            <TableCell key={indx} style={{ fontWeight: 'bold' }}>
                                                                                {each}
                                                                            </TableCell>
                                                                        );
                                                                    }
                                                                )}
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {this.state.popup_table.filteredData?.map(
                                                                (each, index) => {
                                                                    return (
                                                                        <TableRow
                                                                            key={index}
                                                                            hover
                                                                            style={
                                                                                each.disabled
                                                                                    ? {
                                                                                        opacity: 0.5,
                                                                                        pointerEvents: "none",
                                                                                    }
                                                                                    : null
                                                                            }
                                                                        >
                                                                            {this.state.popup_table.header?.map(
                                                                                (one, indx) => {
                                                                                    return (
                                                                                        <TableCell key={indx}>
                                                                                            {each[one]}
                                                                                        </TableCell>
                                                                                    );
                                                                                }
                                                                            )}
                                                                        </TableRow>
                                                                    );
                                                                }
                                                            )}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            )}
                                        </div>
                                    </>
                                }
                                handleClose={() =>
                                    this.setState({
                                        open_popup_select: false,
                                        popup_table: false,
                                    })
                                }
                            />
                        )}
                    {this.state.alert}
                    {this.state.DialougeBox}
                    <div style={{ position: "fixed", top: 70, right: 35, zIndex: 999 }}>
                        {this.state.showScrollButton && !this.props.PDF_Key ? (
                            <>
                                <IconButton
                                    color="primary"
                                    style={{ border: "none", fontSize: "large" }}
                                    onClick={this.scrollToTop}
                                >
                                    <ArrowCircleUpOutlinedIcon />
                                </IconButton>
                                <br />
                                <IconButton
                                    color="primary"
                                    style={{ border: "none", fontSize: "large" }}
                                    onClick={this.scrollToBottom}
                                >
                                    <ArrowCircleDownOutlinedIcon />
                                </IconButton>
                                <br />
                                <IconButton
                                    color="success"
                                    style={{ border: "none", fontSize: "large" }}
                                    onClick={() => {
                                        !this.state.ReferenceName
                                            ? this.setState({
                                                DialougeBox: (
                                                    <DialougeBox
                                                        onClose={() =>
                                                            this.setState({
                                                                DialougeBox: null,
                                                                ReferenceName: null,
                                                            })
                                                        }
                                                        title={"To save Draft set a Reference Name"}
                                                        message={
                                                            <>
                                                                <TextField
                                                                    autoFocus
                                                                    required
                                                                    margin="dense"
                                                                    id="name"
                                                                    name="Refrence name"
                                                                    label="Refrence name"
                                                                    type="text"
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    onChange={(e) =>
                                                                        this.setState({
                                                                            ReferenceName: e.target.value,
                                                                        })
                                                                    }
                                                                />
                                                            </>
                                                        }
                                                        operation={() => this.SaveDraft("false")}
                                                    />
                                                ),
                                            })
                                            : this.SaveDraft("true");
                                    }}
                                >
                                    <SaveAsRoundedIcon />
                                </IconButton>
                                <br />
                                {this.state.ReferenceName && (
                                    <IconButton
                                        color="error"
                                        style={{ border: "none", fontSize: "large" }}
                                        onClick={() => {
                                            this.setState({
                                                DialougeBox: (
                                                    <DialougeBox
                                                        status={"warning"}
                                                        onClose={() => this.setState({ DialougeBox: null })}
                                                        message={
                                                            "Are you sure you want to delete the draft ?"
                                                        }
                                                        operation={() => this.DeleteDraft}
                                                    />
                                                ),
                                            });
                                        }}
                                    >
                                        <DeleteIcon />
                                    </IconButton>
                                )}
                            </>
                        ) : null}
                    </div>

                    <div
                        className={
                            this.props.PDF_Key && this.state.token === "BillExtract"
                                ? "col-lg-6"
                                : "col-lg-12"
                        }
                        style={{
                            flex: 1,
                            overflowY: "auto",
                            maxHeight: "calc(100vh - 80px)",
                        }}
                        ref={this.containerRef}
                    >
                        <Accordion defaultActiveKey={1} alwaysOpen={true}>
                            {(this.props.VR2_Form_Json.length > 0 &&
                                this.props.VR2_Form_Json?.map((treeNode, index) => {
                                    if (
                                        treeNode.type &&
                                        treeNode.type !== "validate_button" &&
                                        treeNode.type !== "submit_button"
                                    ) {
                                        return (
                                            <>
                                                <div className="row">
                                                    <div
                                                        className={
                                                            treeNode.divisonView === "v"
                                                                ? "col-lg-6"
                                                                : "col-lg-12"
                                                        }
                                                    >
                                                        <MyForm
                                                            selectedItem={localStorage.getItem(
                                                                "selectedItem",
                                                            )}
                                                            tree={treeNode}
                                                            screenName={this.props.screenName}
                                                            rerender={this.rerender}
                                                            time={this.state.time}
                                                            toParent={this.toParent}
                                                            onVendorIDonChange={
                                                                this.state.fnToCallonVendorIDonChange
                                                            }
                                                        ></MyForm>
                                                    </div>
                                                    <div
                                                        className={
                                                            treeNode.divisonView === "v"
                                                                ? "col-lg-6"
                                                                : "col-lg-12"
                                                        }
                                                    >
                                                        <MyTable
                                                            selectedItem={localStorage.getItem(
                                                                "selectedItem",
                                                            )}
                                                            tableData={treeNode}
                                                            screenName={this.props.screenName}
                                                            rerender={this.rerender}
                                                            time={this.state.time}
                                                            setRejectorApprovalStatus={
                                                                this.setRejectorApprovalStatus
                                                            }
                                                            setFnToCallonVendorIDonChange={(func) =>
                                                                this.setState({
                                                                    fnToCallonVendorIDonChange: func,
                                                                })
                                                            }
                                                        ></MyTable>
                                                    </div>
                                                </div>
                                            </>
                                        );
                                    }
                                })) ||
                                ""}
                            <div
                                style={{
                                    position: "sticky",
                                    padding: "8px 8px 8px 30px",
                                    bottom: "0",
                                    left: "0",
                                    width: "100%",
                                    zIndex: "1000",
                                    backgroundColor: "#EEEEEE",
                                    display: "flex",
                                    alignItems: "center",
                                    flexWrap: "wrap",
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        flex: 1,
                                    }}
                                >
                                    {this.props.onBack && (
                                        <button
                                            style={{
                                                margin: "0 0 0 1rem",
                                                whiteSpace: "nowrap", // 👈 keeps text inside
                                            }}
                                            className="btn btn-secondary"
                                            onClick={this.onClickBack}
                                        >
                                            <TbArrowBackUp /> Go Back
                                        </button>
                                    )}
                                </div>
                                <div
                                    style={{
                                        display: "flex",
                                        flex: 1,
                                    }}
                                >
                                    {(this.props.VR2_Form_Json.length > 0 &&
                                        this.props.VR2_Form_Json.map((treeNode, index) => {
                                            if (
                                                treeNode.type &&
                                                treeNode.type === "validate_button" &&
                                                treeNode.render &&
                                                treeNode.render === "true"
                                            ) {
                                                return (
                                                    <button
                                                        onClick={this.onClick_Validate}
                                                        className="btn btn-warning"
                                                        style={{
                                                            opacity:
                                                                treeNode.editable === "false" ? "0.4" : "1",
                                                            margin: "0 0 0 1rem",
                                                        }}
                                                        disabled={
                                                            treeNode.editable && treeNode.editable === "false"
                                                        }
                                                    >
                                                        {treeNode.title}
                                                    </button>
                                                );
                                            } else if (
                                                treeNode.type &&
                                                treeNode.type === "submit_button" &&
                                                treeNode.render &&
                                                treeNode.render === "true"
                                            ) {
                                                return (
                                                    <button
                                                        onClick={this.onClick_Activate}
                                                        className="btn btn-primary"
                                                        style={{
                                                            opacity:
                                                                treeNode.editable === "false" ? "0.4" : "1",
                                                            margin: "0 0 0 1rem",
                                                        }}
                                                        disabled={
                                                            treeNode.editable && treeNode.editable === "false"
                                                        }
                                                    >
                                                        {treeNode.title}
                                                    </button>
                                                );
                                            }
                                        })) ||
                                        ""}
                                    {this.state.token === "BillExtract" && (
                                        <button
                                            style={{
                                                margin: "0 0 0 1rem",
                                                whiteSpace: "nowrap", // 👈 keeps text inside
                                            }}
                                            onClick={() =>
                                                this.setState({
                                                    DialougeBox: (
                                                        <DialougeBox
                                                            status={"warning"}
                                                            onClose={() =>
                                                                this.setState({ DialougeBox: null })
                                                            }
                                                            message={
                                                                "This process will change the interim id, Are you sure? (If yes check the latest log)"
                                                            }
                                                            operation={() => this.handleReExtract()}
                                                        />
                                                    ),
                                                })
                                            }
                                            className="btn btn-danger"
                                        >
                                            Retry Extraction
                                        </button>
                                    )}
                                    {this.state.token === "VendorMaster" && (
                                        <button
                                            style={{
                                                margin: "0 0 0 1rem",
                                                whiteSpace: "nowrap", // 👈 keeps text inside
                                            }}
                                            onClick={() => {
                                                const defaultMessage = `
        <style>
            #admin-message-content:empty:before {
                content: attr(data-placeholder);
                color: #9ca3af;
                pointer-events: none;
                display: block;
            }
        </style>
        <div style="background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%); color: #ffffff; padding: 30px; text-align: center; border-bottom: 6px solid #fbbf24;" contenteditable="false">
            <h1 style="margin: 0; font-size: 24px; font-family: sans-serif;">Action Required</h1>
        </div>
        <div style="padding: 30px; font-family: sans-serif; color: #334155; line-height: 1.6; outline: none;" contenteditable="true">
            <p style="font-size: 18px; font-weight: 600; color: #001f3f; margin-top: 0;">Dear Vendor,</p>
            <p>Our administration team has reviewed your submission and is requesting some changes before we can proceed.</p>
            
            <div style="background-color: #fef3c7; border-left: 4px solid #f59e0b; padding: 15px 20px; border-radius: 0 8px 8px 0; margin: 25px 0; color: #92400e;" contenteditable="false">
                <strong>Admin Message:</strong> 
                <div id="admin-message-content" contenteditable="true" data-placeholder="[Type your message to the vendor here]" style="margin-top: 10px; min-height: 50px; border: 1px dashed rgba(245, 158, 11, 0.5); padding: 10px; background: #fff; border-radius: 4px; outline: none;"></div>
            </div>

            <p>Please log in to your portal and update the required information at your earliest convenience.</p>
            
            <div style="text-align: center; margin: 30px 0;" contenteditable="false">
                <a href="https://vp-dev.d1qtjia2b8rdgu.amplifyapp.com/pages/registration/${JSON.parse(localStorage.getItem('selectedItem'))?.id}" target="_blank" style="background-color: #f59e0b; color: white; padding: 12px 24px; text-decoration: none; border-radius: 6px; font-weight: bold; display: inline-block;">Log in to Portal</a>
            </div>
            
            <p style="margin-top: 40px; margin-bottom: 0;">Best Regards,<br><strong style="color: #f59e0b;">The Administration Team</strong></p>
        </div>
        <div style="background-color: #f8fafc; padding: 20px; text-align: center; color: #64748b; font-size: 13px; font-family: sans-serif;" contenteditable="false">
            <p style="margin: 0;">© 2026 Your Company. All rights reserved.</p>
        </div>
    `;
                                                const selectedItem = JSON.parse(localStorage.getItem("selectedItem") || "{}");
                                                const vendorEmail = selectedItem['emailid'] || selectedItem['vendoremail'] || "";
                                                this.setState({
                                                    openChangesEmailDialog: true,
                                                    changesEmailTo: vendorEmail,
                                                    changesEmailMessage: defaultMessage
                                                });
                                            }}
                                            className="btn btn-danger"
                                        >
                                            Request for changes
                                        </button>
                                    )}
                                </div>

                                {this.state.token === "BillExtract" && (
                                    <div
                                        style={{
                                            display: "flex",
                                            flex: 1,
                                            gap: "16px",
                                            justifyContent: "flex-end",
                                            fontSize: "15px",
                                        }}
                                    >
                                        <button
                                            className="btn btn-info"
                                            style={{ whiteSpace: "nowrap" }}
                                            onClick={() => this.handleValidatePopup("Processed")}
                                        >
                                            Extraction Review
                                        </button>
                                        <button
                                            className="btn btn-info"
                                            style={{ whiteSpace: "nowrap" }}
                                            onClick={() => this.handle3WayMatchingPopup()}
                                        >
                                            3 way matching
                                        </button>
                                        {/* <label
                      style={{
                        display: 'flex',
                        gap: '16px',
                        alignItems: 'center',
                        margin: 0,
                        whiteSpace: 'nowrap',
                        fontSize: '15px'
                      }}
                    >
                      <input
                        type='checkbox'
                        checked={this.state.showpopup}
                        onClick={() => this.handleValidatePopup('Validated')}
                      />
                      Validation Review
                    </label> */}
                                        <label
                                            style={{
                                                display: "flex",
                                                gap: "16px",
                                                alignItems: "center",
                                                margin: 0,
                                                whiteSpace: "nowrap",
                                                fontSize: "15px",
                                            }}
                                        >
                                            <input
                                                type="checkbox"
                                                checked={
                                                    this.state[this.state.token] &&
                                                    this.state[this.state.token].GSTasExp
                                                }
                                                onClick={() =>
                                                    this.TDSAsExp("GSTReference", "GSTasExp", "GSTasExp")
                                                }
                                            />
                                            GST as Exp
                                        </label>
                                        <label
                                            style={{
                                                display: "flex",
                                                gap: "16px",
                                                alignItems: "center",
                                                margin: 0,
                                                whiteSpace: "nowrap",
                                                fontSize: "15px",
                                            }}
                                        >
                                            <input
                                                type="checkbox"
                                                checked={
                                                    this.state[this.state.token] &&
                                                    this.state[this.state.token].TDSasExp
                                                }
                                                onClick={() =>
                                                    this.TDSAsExp("TDSReference", "TDSasExp", "TDSasExp")
                                                }
                                            />
                                            TDS As Exp
                                        </label>
                                    </div>
                                )}
                                {this.state.token === "GoodsAndServicesEntries" && (
                                    <div
                                        style={{
                                            display: "flex",
                                            flex: 1,
                                            gap: "16px",
                                            justifyContent: "flex-end",
                                        }}
                                    >
                                        <label
                                            style={{
                                                display: "flex",
                                                gap: "16px",
                                                alignItems: "center",
                                                margin: 0,
                                                whiteSpace: "nowrap",
                                                fontSize: "15px",
                                            }}
                                        >
                                            <input
                                                type="checkbox"
                                                checked={
                                                    this.state[this.state.token] &&
                                                    this.state[this.state.token].DeductTDS
                                                }
                                                onClick={() =>
                                                    this.TDSAsExp(
                                                        "DeductionRef",
                                                        "DeductTDS",
                                                        "DeductTDS",
                                                    )
                                                }
                                            />
                                            Deduct TDS
                                        </label>
                                    </div>
                                )}
                            </div>
                            <Spinner open={this.state.showSpinner} />
                        </Accordion>
                    </div>
                    {this.props.PDF_Key && this.state.token === "BillExtract" && (
                        <div
                            className="col-lg-6"
                            style={{
                                position: "sticky",
                                top: "64px", // adjust for your navbar height
                                alignSelf: "flex-start",
                                maxHeight: "calc(100vh - 64px)",
                                overflowY: "auto",
                                background: "#fff",
                                boxShadow: "0 0 10px rgba(0,0,0,0.1)",
                                zIndex: 100,
                            }}
                        >
                            <>
                                <Drawer
                                    anchor="right"
                                    open={Boolean(this.props.PDF_Key)}
                                    onClose={() => this.props.update_one_side_PDF_Key(false, "")}
                                    variant="persistent"
                                    ModalProps={{
                                        keepMounted: true,
                                        hideBackdrop: true,
                                    }}
                                    PaperProps={{
                                        sx: {
                                            width: "100%",
                                            position: "sticky",
                                            marginTop: "64px",
                                        },
                                    }}
                                >
                                    {this.props.PDF_Key && this.state.token === "BillExtract" && (
                                        <div style={{ padding: "8px" }}>
                                            {/* Close Button */}
                                            <div style={{ textAlign: "right" }}>
                                                <IconButton
                                                    color="error"
                                                    onClick={() =>
                                                        this.props.update_one_side_PDF_Key(false, "")
                                                    }
                                                >
                                                    <CloseIcon />
                                                </IconButton>
                                            </div>

                                            {/* PDF / Image Preview */}
                                            {this.props.PDF_Key ? (
                                                this.props.fileType.toLowerCase() === "pdf" ? (
                                                    <iframe
                                                        src={this.props.PDF_Key}
                                                        title="pdf-viewer"
                                                        style={{
                                                            width: "100%",
                                                            height: "70vh",
                                                            border: "none",
                                                        }}
                                                        allowFullScreen
                                                    />
                                                ) : (
                                                    <img
                                                        src={this.props.PDF_Key}
                                                        alt="preview"
                                                        style={{
                                                            width: "100%",
                                                            height: "70vh",
                                                            border: "none",
                                                        }}
                                                    />
                                                )
                                            ) : (
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        height: "100%",
                                                    }}
                                                >
                                                    <CircularProgress />
                                                </Box>
                                            )}
                                        </div>
                                    )}
                                </Drawer>
                            </>
                        </div>
                    )}

                    {/* Changes Email Dialog */}
                    <Dialog open={this.state.openChangesEmailDialog || false} onClose={() => this.setState({ openChangesEmailDialog: false })} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: 2 } }}>
                        <DialogTitle sx={{ bgcolor: '#f4f6f8', pb: 2, fontWeight: 600 }}>Request Changes from Vendor</DialogTitle>
                        <DialogContent sx={{ display: 'flex', flexDirection: 'column', pt: '16px !important' }}>
                            <TextField
                                margin="dense"
                                label="From"
                                type="text"
                                fullWidth
                                variant="outlined"
                                InputLabelProps={{ shrink: true }}
                                value="solve@datatwin.ai"
                                disabled
                            />
                            <TextField
                                autoFocus
                                margin="dense"
                                label="To (Vendor Email)"
                                type="email"
                                fullWidth
                                variant="outlined"
                                InputLabelProps={{ shrink: true }}
                                value={this.state.changesEmailTo || ""}
                                onChange={(e) => this.setState({ changesEmailTo: e.target.value })}
                                sx={{ mb: 2 }}
                            />
                            <Typography variant="subtitle2" color="textSecondary" sx={{ mb: 1, mt: 1 }}>Message Template (Click inside the yellow box to type your specific changes request)</Typography>
                            <div style={{ border: '1px solid rgba(135, 206, 235, 0.4)', borderRadius: 8, margin: 0, boxShadow: '0 4px 12px rgba(0,0,0,0.05)', height: '400px', overflowY: 'auto' }}>
                                <div
                                    ref={this.emailContentRef}
                                    dangerouslySetInnerHTML={{ __html: this.state.changesEmailMessage }}
                                    style={{ margin: 0, fontFamily: 'sans-serif', background: '#fff' }}
                                />
                            </div>
                        </DialogContent>
                        <DialogActions sx={{ p: 2, bgcolor: '#f4f6f8' }}>
                            <Button onClick={() => this.setState({ openChangesEmailDialog: false })} color="inherit" sx={{ mr: 1 }}>
                                Cancel
                            </Button>
                            <Button
                                onClick={() => this.handleSendChangesEmail()}
                                color="error"
                                variant="contained"
                                disabled={!this.state.changesEmailTo || !this.state.changesEmailTo.includes('@')}
                            >
                                Send & Request Changes
                            </Button>
                        </DialogActions>
                    </Dialog>

                </div>
            );
        } else {
            console.log(
                this.props.dependency_json, "prop");

            return <>{this.state.status}</>;
        }
    }
}

function mapStateToProps(state) {
    return {
        VR2_Form_Json: state.VR2.VR2_Form_Json,
        changeLogs: state.VR2.changeLogs,
        storeVals: state.VR2.storeVals,
        dependency_json: state.VR2.dependency_json,
        ORG_ID_CONST: state.VR2.ORG_ID_CONST,
        PDF_Key: state.VR2.PDF_Key,
        fileType: state.VR2.fileType,
    };
}

export default connect(mapStateToProps, {
    fetchTreeData,
    handleTreeChange,
    update_dependencyJson,
    updateStoreVals,
    update_one_side_PDF_Key,
    Set_ORG_ID_CONST,
    showLoader,
    hideLoader,
    navUrl,
})(DisplayContainer);
